import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import { modifyUnionName, modifyUnionMaster, modifyUnionNotice, dismissUnion } from "@/api/union";
export default {
  name: "showUnionMsg",
  props: {
    formData: Object
  },
  data: function data() {
    return {
      value: "",
      options: [{
        label: "修改工会会长",
        value: "type1"
      }, {
        label: "修改工会名称",
        value: "type2"
      }, {
        label: "修改工会公告",
        value: "type3"
      }, {
        label: "解散工会",
        value: "type4"
      }],
      // formInfo: {},
      formInfoType1: {},
      formInfoType2: {},
      formInfoType3: {}
    };
  },
  created: function created() {
    // this.formInfo = JSON.parse(JSON.stringify(this.formInfo));
    this.formInfoType1 = JSON.parse(JSON.stringify(this.formData));
    this.formInfoType2 = JSON.parse(JSON.stringify(this.formData));
    this.formInfoType3 = JSON.parse(JSON.stringify(this.formData));
  },
  methods: {
    confirmbtn: function confirmbtn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, _res, _res2, _res3;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.value == "type1")) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return modifyUnionMaster(_this.formInfoType1);
            case 3:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "保存成功"
                });
                _this.$emit("backMsg", false);
              } else {
                _this.$message({
                  type: "error",
                  message: "出错啦"
                });
              }
              _context.next = 26;
              break;
            case 7:
              if (!(_this.value == "type2")) {
                _context.next = 14;
                break;
              }
              _context.next = 10;
              return modifyUnionName(_this.formInfoType2);
            case 10:
              _res = _context.sent;
              if (_res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "保存成功"
                });
                _this.$emit("backMsg", false);
              } else {
                _this.$message({
                  type: "error",
                  message: "出错啦"
                });
              }
              _context.next = 26;
              break;
            case 14:
              if (!(_this.value == "type3")) {
                _context.next = 21;
                break;
              }
              _context.next = 17;
              return modifyUnionNotice(_this.formInfoType3);
            case 17:
              _res2 = _context.sent;
              if (_res2.code == 0) {
                _this.$message({
                  type: "success",
                  message: "保存成功"
                });
                _this.$emit("backMsg", false);
              } else {
                _this.$message({
                  type: "error",
                  message: "出错啦"
                });
              }
              _context.next = 26;
              break;
            case 21:
              if (!(_this.value == "type4")) {
                _context.next = 26;
                break;
              }
              _context.next = 24;
              return dismissUnion(_this.formData);
            case 24:
              _res3 = _context.sent;
              if (_res3.code == 0) {
                _this.$message({
                  type: "success",
                  message: "保存成功"
                });
                _this.$emit("backMsg", false);
              } else {
                _this.$message({
                  type: "error",
                  message: "出错啦"
                });
              }
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};